import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'
import { USER_TYPES, UserTypes } from '../Types'

export const useActionActivity = (projectId: string, userId: string, type: UserTypes) => {
  const p =
    type === USER_TYPES.CLINICIAN
      ? ENDPOINTS.CLINICIANS.actions(projectId, userId)
      : ENDPOINTS.TRIAL_STAFF.actions(projectId, userId)

  const { data, error, mutate } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? data : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
